import script from "./ManagementView.vue?vue&type=script&lang=ts&setup=true"
export * from "./ManagementView.vue?vue&type=script&lang=ts&setup=true"

import "./ManagementView.vue?vue&type=style&index=0&id=7b5a39b0&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7b5a39b0"]])

export default __exports__